import classNames from "classnames";

// Components
import Timer from "components/atoms/Timer";

// Hooks
import useTranslate from "hooks/useTranslate";
import { useBreakpoint } from "hooks/useBreakpoint";

import "./styles.sass";

interface ITournamentPrize {
  totalPrizePool: number;
  endDate: string;
}

const TournamentPrize: React.FC<ITournamentPrize> = ({
  totalPrizePool,
  endDate,
}) => {
  const t = useTranslate();
  const { isDesktop } = useBreakpoint();
  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  const tournamentPrizeClass = classNames("TournamentPrize", {
    banger: VITE_APP_PROJECT_NAME === "banger",
  });

  return (
    <div className={tournamentPrizeClass}>
      <div className="TournamentPrize_block">
        <div className="TournamentPrize_block-title">
          {t("page.tournament.prize.pool")}
        </div>
        <div className="TournamentPrize_block-content">€ {totalPrizePool}</div>
      </div>
      <div className="TournamentPrize_timer">
        <div className="TournamentPrize_timer-title">
          {t("page.tournament.end.title")}
        </div>
        <div className="TournamentPrize_timer-content">
          <Timer
            finishDate={endDate}
            mask="DD:HH:mm:ss"
            isBonus
            warningPaint
            size={isDesktop ? "large" : "medium"}
          />
        </div>
      </div>
    </div>
  );
};

export default TournamentPrize;
